module.exports = __webpack_public_path__ + "media/images/presta_busc/nutricionista-50947a5f55a932d14a86bb339d84a12e.svg";